export interface GtmProperties {
    auth: string;
    containerId: string;
    environment: string;
    serverUrl: string;
    spaceId: number;
}

interface InlineScript {
    key: string;
    textContent: string;
}

export function createGtmHeadScripts(configuration: GtmProperties): InlineScript[] {
    const dataLayerScript =
        `window.dataLayer = window.dataLayer || [];` +
        `window.dataLayer.push({"app_id":${JSON.stringify(configuration.spaceId)}});`;

    const loaderScript =
        `(function(w,d,s,l,i){` +
        `w[l]=w[l]||[];` +
        `w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});` +
        `var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';` +
        `j.async=true;` +
        `j.src=${JSON.stringify(configuration.serverUrl)}+'/gtm.js?id='+i+dl+` +
        `'&gtm_auth='+${JSON.stringify(configuration.auth)}+` +
        `'&gtm_preview='+${JSON.stringify(configuration.environment)}+'&gtm_cookies_win=x';` +
        `f.parentNode.insertBefore(j,f);` +
        `})(window,document,'script','dataLayer',${JSON.stringify(configuration.containerId)});`;

    return [
        { key: "gtm-data-layer", textContent: dataLayerScript },
        { key: "gtm-loader", textContent: loaderScript }
    ];
}
